import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Form, Modal } from 'react-bootstrap';
import './Payment.css';
import axios from 'axios';

const tg = window.Telegram.WebApp;
const API_URL = 'https://api.malevich.sverhum.ru/apivk';
const DONUT_URL = 'https://vk.com/donut_payment-177029630';

const Payment = () => {
  const [showContacts, setShowContacts] = useState(false);
  const [showDescription, setShowDescription] = useState(false);
  const [id, setId] = useState(null);
  const [TG, setTG] = useState(false);
  const [VK, setVK] = useState(false);
  const [product, setProduct] = useState('1');
  const [email, setEmail] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('card');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const idFromURL = queryParams.get('id');
    if (idFromURL) {
      setId(Number(idFromURL));
      setVK(true);
    }
  }, []);

  useEffect(() => {
    if (tg?.initDataUnsafe?.user) {
      setTG(true);
      setId(tg.initDataUnsafe.user.id);
    }
  }, []);

  const openPaymentUrl = (url) => {
    const safeUrl = String(url || '').trim();
    if (!safeUrl) return;
    try {
      if (TG && tg?.openLink) {
        tg.openLink(safeUrl);
        return;
      }
    } catch (_) {}
    window.open(safeUrl, '_blank');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (id == null || !product) return alert('Укажите ID и тариф');

    if (paymentMethod === 'vkpay') {
      if (!VK) {
        return window.open(`https://vk.com/write-177029630?ref=${id}&ref_source=3`, '_blank');
      }
      return window.open(DONUT_URL, '_blank');
    }

    setLoading(true);
    try {
      const response = await axios.post(API_URL, {
        method: 'create',
        product,
        id,
        email,
        paymentMethod: 'yookassa',
        currency: 'RUB'
      });

      if (response.data?.payment_url) {
        return openPaymentUrl(response.data.payment_url);
      }
      alert(response.data?.message || 'Ошибка при создании платежа');
    } catch (error) {
      console.error('Error during payment creation:', error);
      alert('Ошибка при создании платежа');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="payment-page">
      <Container>
        <Row className="justify-content-center">
          <Col md={6} lg={4} className="order-md-1">
            <Card className="payment-card">
              <Card.Body>
                <Card.Title className="text-center">Оплата</Card.Title>
                <Form onSubmit={handleSubmit}>
                  {TG === false && VK === false && (
                    <Form.Group className="mb-3">
                      <Form.Label>ID ВКонтакте</Form.Label>
                      <Form.Control
                        placeholder="Ваш VK ID"
                        defaultValue={id || ''}
                        onChange={(e) => setId(e.target.value)}
                        required
                      />
                    </Form.Group>
                  )}
                  <Form.Group className="mb-3">
                    <Form.Label>Тариф</Form.Label>
                    <Form.Control as="select" value={product} onChange={(e) => setProduct(e.target.value)}>
                      <option value="1">Старт 1 месяц — 350 ₽</option>
                      <option value="2">Мастер 1 месяц — 700 ₽</option>
                      <option value="10">ТОП мастер — 1 000 ₽</option>
                      <option value="3">Годовой — 5 400 ₽</option>
                      <option value="7">Beautystar Старт — 24 900 ₽</option>
                      <option value="8">Beautystar Мастер — 39 900 ₽</option>
                      <option value="9">Beautystar Предприниматель — 84 900 ₽</option>
                    </Form.Control>
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Способ оплаты</Form.Label>
                    <Form.Control
                      as="select"
                      value={paymentMethod}
                      onChange={(e) => setPaymentMethod(e.target.value)}
                    >
                      <option value="card">Карта / СБП</option>
                      {product !== '3' && <option value="vkpay">VK Donut</option>}
                    </Form.Control>
                  </Form.Group>
                  {paymentMethod === 'vkpay' && (
                    <Form.Group className="mb-3">
                      <Form.Text>
                        Откроется оплата VK Donut. Для активации подпишите донат в сообществе Малевича.
                      </Form.Text>
                    </Form.Group>
                  )}
                  {paymentMethod !== 'vkpay' && (
                    <Form.Group className="mb-3">
                      <Form.Label>Email для чека</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="email@example.com"
                        defaultValue={email || ''}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </Form.Group>
                  )}
                  <Button variant="primary" type="submit" className="w-100" disabled={loading}>
                    {loading ? 'Создаём оплату…' : 'Оплатить'}
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
          <Col
            md={6}
            lg={4}
            className="order-md-2 d-flex flex-column align-items-center justify-content-center mt-4 mt-md-0"
          >
            <div className="button-group">
              <button className="custom-btn" type="button" onClick={() => setShowDescription(true)}>
                Описание товаров
              </button>
              <button className="custom-btn" type="button" onClick={() => setShowContacts(true)}>
                Контакты
              </button>
            </div>
            <div className="button-group">
              <Button className="custom-btn mt-3 user-agreement" href="https://sverhum.ru/page1.html" target="_blank">
                Пользовательское соглашение
              </Button>
              <Button className="custom-btn mt-3 user-agreement" href="https://t.me/dropsupport" target="_blank">
                Отменить продление
              </Button>
            </div>
          </Col>
        </Row>
      </Container>

      <Modal show={showContacts} onHide={() => setShowContacts(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Контакты</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul className="popup__inner-list">
            <p className="popup__inner-main-title">Связаться</p>
            <p className="popup__inner-item">ИНН - 583509348538</p>
            <p className="popup__inner-item">Почта: catkonfis@gmail.com</p>
            <p className="popup__inner-item">TG: https://t.me/dropsupport</p>
          </ul>
        </Modal.Body>
      </Modal>

      <Modal show={showDescription} onHide={() => setShowDescription(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Описание товаров</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul className="popup__inner-list">
            <p className="popup__inner-main-title">
              Авторские инструменты, шаблоны для социальных сетей и образования.
            </p>
            <p className="popup__inner-item">Старт — 350 ₽/мес: нейро-создание контента</p>
            <p className="popup__inner-item">Мастер — 700 ₽/мес: контент + библиотека шаблонов</p>
            <p className="popup__inner-item">ТОП мастер — 1 000 ₽/мес: расширенные разделы</p>
            <p className="popup__inner-item">Годовой — 5 400 ₽/год: тариф Мастер с выгодой 50%</p>
          </ul>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Payment;
